import { render, staticRenderFns } from "./case-images.vue?vue&type=template&id=bf5dbb88&scoped=true"
import script from "./case-images.vue?vue&type=script&lang=js"
export * from "./case-images.vue?vue&type=script&lang=js"
import style0 from "./case-images.vue?vue&type=style&index=0&id=bf5dbb88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5dbb88",
  null
  
)

export default component.exports